<script setup>
import SectionTitle from "@/components/reusable/SectionTitle.vue";
import testimonials from "../../data/testimonials";
import { inject, computed } from "vue";

// Inject the reactive theme state
const themeState = inject("themeState");

// Method for background color based on theme
const getBackgroundColor = (color) => {
  if (themeState.theme === "light") {
    const hex = color.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, 0.05)`; // Light theme with low opacity
  } else {
    return "#1E3851"; // Dark theme background color
  }
};
</script>

<template>
  <section class="pt-14 md:pt-16 pb-10 md:pb-12">
    <SectionTitle
      title="Testimonials"
      desc="Here's what others have to say about me"
    />

    <div
      class="mt-14 md:mt-16 [column-fill:_balance] sm:columns-2 sm:gap-6 lg:columns-3 lg:gap-8"
    >
      <div
        v-for="testimonial in testimonials"
        :key="testimonial.name"
        class="mb-8 sm:break-inside-avoid"
      >
        <blockquote
          :style="`background-color: ${getBackgroundColor(
            testimonial.color
          )}; border-color: ${testimonial.color}; `"
          class="p-6 md:p-8 rounded-md shadow-lg hover:shadow-xl hover:scale-[1.01] duration-200 cursor-pointer mb-10 border-b-2 border-blue-500 sm:mb-0 dark:bg-ternary-dark"
        >
          <div class="flex items-center gap-4">
            <img
              class="w-12 h-12 rounded-full object-cover shadow-md"
              :src="testimonial.client_img"
              :alt="testimonial.name"
              width="400"
              height="400"
              loading="lazy"
            />

            <div>
              <p
                class="text-lg font-medium text-ternary-dark dark:text-ternary-light"
              >
                {{ testimonial.name }}
              </p>
              <h1
                class="text-sm text-ternary-dark dark:text-ternary-light italic -mt-[2px]"
              >
                {{ testimonial.credit }}
              </h1>
            </div>
          </div>

          <p class="mt-4 text-ternary-dark dark:text-ternary-light">
            {{ testimonial.testimonial }}
          </p>
        </blockquote>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped></style>
